/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useQuery } from '@apollo/client';

import { DedicatedProjectsInHeaderDocument } from '@fai/friendli-suite/generated/client/graphql';

export const useProjectsInHeader = (teamId: string) => {
  const { data: _data } = useQuery(DedicatedProjectsInHeaderDocument, {
    variables: { teamId, sorts: { ascending: false, sortBy: 'created_at' } },
    fetchPolicy: 'cache-and-network',
  });

  const data = _data?.dedicatedSubplan?.projects?.edges?.map(({ node }) => ({
    id: node.id,
    name: node.name,
  }));

  return { data };
};
